import React from 'react';
import TituloMuroLambrinConcavo from '../components/sections/MuroLambrinConcavo/TituloMuroLambrinConcavo';
import IntroMuroLambrinConcavo from '../components/sections/MuroLambrinConcavo/IntroMuroLambrinConcavo';
import CaracteristicasMuroLambrinConcavo from '../components/sections/MuroLambrinConcavo/CaracteristicasMuroLambrinConcavo';
import FormularioContactoConcavo from '../components/sections/MuroLambrinConcavo/FormularioContactoConcavo';
import Header from '../components/layouts/Header'; 
import Footer from '../components/layouts/Footer';

const MuroLambrinConcavo = () => {
  return (
    <div>
      <Header />

        <TituloMuroLambrinConcavo /> 
        <IntroMuroLambrinConcavo />
        <CaracteristicasMuroLambrinConcavo />  
        <FormularioContactoConcavo />  
      <Footer />
    </div>
  );
};

export default MuroLambrinConcavo;